var _rect, _circle, _circle2, _circle3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalTroYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140.6 307.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140.6,
    height: 307.76,
    ry: 44.816
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.319,
    cy: 60.73,
    r: 44.596,
    fill: "#666"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.659,
    cy: 249.71,
    r: 44.596,
    fill: "#666"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.159,
    cy: 155.72,
    r: 44.596,
    fill: "none",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085.6 -364.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: -1042.6,
    y: -525.08,
    width: 56.38,
    height: 9.0781,
    ry: 4.5391,
    fill: "#fff",
    strokeWidth: 3.1191
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalTroYellow);
export default __webpack_public_path__ + "static/media/signal_tro_yellow.40f57cf47122f4ddb87c61a0c45100ad.svg";
export { ForwardRef as ReactComponent };